import no_spoonerismIntro from 'assets/sounds/no/spoonerism/intro.mp3';
import no_spoonerismIntroEnd from 'assets/sounds/no/spoonerism/intro-end.mp3';
import no_proveoppgave1 from 'assets/sounds/no/spoonerism/proveoppgave-1.mp3';
import no_proveoppgave2 from 'assets/sounds/no/spoonerism/proveoppgave-2.mp3';
import no_proveoppgave3 from 'assets/sounds/no/spoonerism/proveoppgave-3.mp3';
import no_correct1 from 'assets/sounds/no/spoonerism/correct-1.mp3';
import no_correct2 from 'assets/sounds/no/spoonerism/correct-2.mp3';
import no_correct3 from 'assets/sounds/no/spoonerism/correct-3.mp3';
import no_incorrect1 from 'assets/sounds/no/spoonerism/incorrect-1.mp3';
import no_incorrect2 from 'assets/sounds/no/spoonerism/incorrect-2.mp3';
import no_incorrect3 from 'assets/sounds/no/spoonerism/incorrect-3.mp3';
import no_sound1 from 'assets/sounds/no/spoonerism/spoonerism-task (1).mp3';
import no_sound2 from 'assets/sounds/no/spoonerism/spoonerism-task (2).mp3';
import no_sound3 from 'assets/sounds/no/spoonerism/spoonerism-task (3).mp3';
import no_sound4 from 'assets/sounds/no/spoonerism/spoonerism-task (4).mp3';
import no_sound5 from 'assets/sounds/no/spoonerism/spoonerism-task (5).mp3';
import no_sound6 from 'assets/sounds/no/spoonerism/spoonerism-task (6).mp3';
import no_sound7 from 'assets/sounds/no/spoonerism/spoonerism-task (7).mp3';
import no_sound8 from 'assets/sounds/no/spoonerism/spoonerism-task (8).mp3';
import no_sound9 from 'assets/sounds/no/spoonerism/spoonerism-task (9).mp3';
import no_sound10 from 'assets/sounds/no/spoonerism/spoonerism-task (10).mp3';
import no_sound11 from 'assets/sounds/no/spoonerism/spoonerism-task (11).mp3';
import no_sound12 from 'assets/sounds/no/spoonerism/spoonerism-task (12).mp3';
import no_sound13 from 'assets/sounds/no/spoonerism/spoonerism-task (13).mp3';
import no_sound14 from 'assets/sounds/no/spoonerism/spoonerism-task (14).mp3';
import no_sound15 from 'assets/sounds/no/spoonerism/spoonerism-task (15).mp3';
import no_sound16 from 'assets/sounds/no/spoonerism/spoonerism-task (16).mp3';
import no_sound17 from 'assets/sounds/no/spoonerism/spoonerism-task (17).mp3';
import no_sound18 from 'assets/sounds/no/spoonerism/spoonerism-task (18).mp3';
import no_sound19 from 'assets/sounds/no/spoonerism/spoonerism-task (19).mp3';
import no_sound20 from 'assets/sounds/no/spoonerism/spoonerism-task (20).mp3';

import nn_spoonerismIntro from 'assets/sounds/nn/spoonerism/intro.mp3';
import nn_spoonerismIntroEnd from 'assets/sounds/nn/spoonerism/intro-end.mp3';
import nn_proveoppgave1 from 'assets/sounds/nn/spoonerism/proveoppgave-1.mp3';
import nn_proveoppgave2 from 'assets/sounds/nn/spoonerism/proveoppgave-2.mp3';
import nn_proveoppgave3 from 'assets/sounds/nn/spoonerism/proveoppgave-3.mp3';
import nn_correct1 from 'assets/sounds/nn/spoonerism/correct-1.mp3';
import nn_correct2 from 'assets/sounds/nn/spoonerism/correct-2.mp3';
import nn_correct3 from 'assets/sounds/nn/spoonerism/correct-3.mp3';
import nn_incorrect1 from 'assets/sounds/nn/spoonerism/incorrect-1.mp3';
import nn_incorrect2 from 'assets/sounds/nn/spoonerism/incorrect-2.mp3';
import nn_incorrect3 from 'assets/sounds/nn/spoonerism/incorrect-3.mp3';
import nn_sound1 from 'assets/sounds/nn/spoonerism/spoonerism-task (1).mp3';
import nn_sound2 from 'assets/sounds/nn/spoonerism/spoonerism-task (2).mp3';
import nn_sound3 from 'assets/sounds/nn/spoonerism/spoonerism-task (3).mp3';
import nn_sound4 from 'assets/sounds/nn/spoonerism/spoonerism-task (4).mp3';
import nn_sound5 from 'assets/sounds/nn/spoonerism/spoonerism-task (5).mp3';
import nn_sound6 from 'assets/sounds/nn/spoonerism/spoonerism-task (6).mp3';
import nn_sound7 from 'assets/sounds/nn/spoonerism/spoonerism-task (7).mp3';
import nn_sound8 from 'assets/sounds/nn/spoonerism/spoonerism-task (8).mp3';
import nn_sound9 from 'assets/sounds/nn/spoonerism/spoonerism-task (9).mp3';
import nn_sound10 from 'assets/sounds/nn/spoonerism/spoonerism-task (10).mp3';
import nn_sound11 from 'assets/sounds/nn/spoonerism/spoonerism-task (11).mp3';
//import nn_sound12 from 'assets/sounds/nn/spoonerism/spoonerism-task (12).mp3';
//import nn_sound13 from 'assets/sounds/nn/spoonerism/spoonerism-task (13).mp3';
//import nn_sound14 from 'assets/sounds/nn/spoonerism/spoonerism-task (14).mp3';
//import nn_sound15 from 'assets/sounds/nn/spoonerism/spoonerism-task (15).mp3';
//import nn_sound16 from 'assets/sounds/nn/spoonerism/spoonerism-task (16).mp3';
//import nn_sound17 from 'assets/sounds/nn/spoonerism/spoonerism-task (17).mp3';
//import nn_sound18 from 'assets/sounds/nn/spoonerism/spoonerism-task (18).mp3';
//import nn_sound19 from 'assets/sounds/nn/spoonerism/spoonerism-task (19).mp3';
//import nn_sound20 from 'assets/sounds/nn/spoonerism/spoonerism-task (20).mp3';

import no_spoonerismIntro_norming from '../../assets/sounds/no/spoonerism/norming/grade6-7/trail/Spoonerism-MT-intro.mp3';
import no_spoonerismIntroEnd_norming from '../../assets/sounds/no/spoonerism/norming/grade6-7/trail/Spoonerism-MT-intro-AFTER-trail.mp3';

import no_proveoppgave1_norming from '../../assets/sounds/no/spoonerism/norming/grade6-7/trail/Spoonerism-MT-TRAIL1.mp3';
import no_correct1_norming from '../../assets/sounds/no/spoonerism/norming/grade6-7/trail/Spoonerism-MT-TRIAL1-if-correct.mp3';
import no_incorrect1_norming from '../../assets/sounds/no/spoonerism/norming/grade6-7/trail/Spoonerism-MT-trial1-if-both-wrong.mp3';
import no_if_one_correct1_norming from '../../assets/sounds/no/spoonerism/norming/grade6-7/trail/Spoonerism-MT-TRIAL1-if-one-correct.mp3';

import no_proveoppgave2_norming from '../../assets/sounds/no/spoonerism/norming/grade6-7/trail/Spoonerism-MT-TRAIL1.mp3';
import no_correct2_norming from '../../assets/sounds/no/spoonerism/norming/grade6-7/trail/Spoonerism-MT-TRIAL2-if-correct.mp3';
import no_incorrect2_norming from '../../assets/sounds/no/spoonerism/norming/grade6-7/trail/Spoonerism-MT-TRIAL2-if-both-wrong.mp3';
import no_if_one_correct2_norming from '../../assets/sounds/no/spoonerism/norming/grade6-7/trail/Spoonerism-MT-TRIAL2-if-one-correct.mp3';

import no_proveoppgave3_norming from '../../assets/sounds/no/spoonerism/norming/grade6-7/trail/Spoonerism-MT-TRAIL1.mp3';
import no_correct3_norming from '../../assets/sounds/no/spoonerism/norming/grade6-7/trail/Spoonerism-MT-TRIAL2-if-correct.mp3';
import no_incorrect3_norming from '../../assets/sounds/no/spoonerism/norming/grade6-7/trail/Spoonerism-MT-TRIAL2-if-both-wrong.mp3';
import no_if_one_correct3_norming from '../../assets/sounds/no/spoonerism/norming/grade6-7/trail/Spoonerism-MT-TRIAL2-if-one-correct.mp3';

import no_sound1_norming from '../../assets/sounds/no/spoonerism/norming/grade6-7/test/Spoonerism-MT-1.mp3';
import no_sound2_norming from '../../assets/sounds/no/spoonerism/norming/grade6-7/test/Spoonerism-MT-2.mp3';
import no_sound3_norming from '../../assets/sounds/no/spoonerism/norming/grade6-7/test/Spoonerism-MT-3.mp3';
import no_sound4_norming from '../../assets/sounds/no/spoonerism/norming/grade6-7/test/Spoonerism-MT-4.mp3';
import no_sound5_norming from '../../assets/sounds/no/spoonerism/norming/grade6-7/test/Spoonerism-MT-5.mp3';
import no_sound6_norming from '../../assets/sounds/no/spoonerism/norming/grade6-7/test/Spoonerism-MT-6.mp3';
import no_sound7_norming from '../../assets/sounds/no/spoonerism/norming/grade6-7/test/Spoonerism-MT-7.mp3';
import no_sound8_norming from '../../assets/sounds/no/spoonerism/norming/grade6-7/test/Spoonerism-MT-8.mp3';
import no_sound9_norming from '../../assets/sounds/no/spoonerism/norming/grade6-7/test/Spoonerism-MT-9.mp3';
import no_sound10_norming from '../../assets/sounds/no/spoonerism/norming/grade6-7/test/Spoonerism-MT-10.mp3';
import no_sound11_norming from '../../assets/sounds/no/spoonerism/norming/grade6-7/test/Spoonerism-MT-11.mp3';
import no_sound12_norming from '../../assets/sounds/no/spoonerism/norming/grade6-7/test/Spoonerism-MT-12.mp3';
import no_sound13_norming from '../../assets/sounds/no/spoonerism/norming/grade6-7/test/Spoonerism-MT-13.mp3';
import no_sound14_norming from '../../assets/sounds/no/spoonerism/norming/grade6-7/test/Spoonerism-MT-14.mp3';
import no_sound15_norming from '../../assets/sounds/no/spoonerism/norming/grade6-7/test/Spoonerism-MT-15.mp3';
import no_sound16_norming from '../../assets/sounds/no/spoonerism/norming/grade6-7/test/Spoonerism-MT-16.mp3';
import no_sound17_norming from '../../assets/sounds/no/spoonerism/norming/grade6-7/test/Spoonerism-MT-17.mp3';
import no_sound18_norming from '../../assets/sounds/no/spoonerism/norming/grade6-7/test/Spoonerism-MT-18.mp3';

import nn_spoonerismIntro_norming from '../../assets/sounds/nn/spoonerism/norming/grade6-7/trail/Instructions.mp3';
import nn_spoonerismIntroEnd_norming from '../../assets/sounds/nn/spoonerism/norming/grade6-7/trail/Instructions-after-trial.mp3';

import nn_proveoppgave1_norming from '../../assets/sounds/nn/spoonerism/norming/grade6-7/trail/TRIAL 1.mp3';
import nn_correct1_norming from '../../assets/sounds/nn/spoonerism/norming/grade6-7/trail/TRIAL 1 if-both-correct.mp3';
import nn_incorrect1_norming from '../../assets/sounds/nn/spoonerism/norming/grade6-7/trail/TRIAL 1 if-both-wrong.mp3';
import nn_if_one_correct1_norming from '../../assets/sounds/nn/spoonerism/norming/grade6-7/trail/TRIAL 1 if-one-correct.mp3';

import nn_proveoppgave2_norming from '../../assets/sounds/nn/spoonerism/norming/grade6-7/trail/TRIAL 2.mp3';
import nn_correct2_norming from '../../assets/sounds/nn/spoonerism/norming/grade6-7/trail/TRIAL 2 if-both-correct.mp3';
import nn_incorrect2_norming from '../../assets/sounds/nn/spoonerism/norming/grade6-7/trail/TRIAL 2 if-both-wrong.mp3';
import nn_if_one_correct2_norming from '../../assets/sounds/nn/spoonerism/norming/grade6-7/trail/TRIAL 2 if-one-correct.mp3';

import nn_proveoppgave3_norming from '../../assets/sounds/nn/spoonerism/norming/grade6-7/trail/TRIAL 3.mp3';
import nn_correct3_norming from '../../assets/sounds/nn/spoonerism/norming/grade6-7/trail/TRIAL 3 if-both-correct.mp3';
import nn_incorrect3_norming from '../../assets/sounds/nn/spoonerism/norming/grade6-7/trail/TRIAL 3 if-both-wrong.mp3';
import nn_if_one_correct3_norming from '../../assets/sounds/nn/spoonerism/norming/grade6-7/trail/TRIAL 3 if-one-correct.mp3';

import nn_sound1_norming from '../../assets/sounds/nn/spoonerism/norming/grade6-7/test/Spoonerism-MT-1.mp3';
import nn_sound2_norming from '../../assets/sounds/nn/spoonerism/norming/grade6-7/test/Spoonerism-MT-2.mp3';
import nn_sound3_norming from '../../assets/sounds/nn/spoonerism/norming/grade6-7/test/Spoonerism-MT-3.mp3';
import nn_sound4_norming from '../../assets/sounds/nn/spoonerism/norming/grade6-7/test/Spoonerism-MT-4.mp3';
import nn_sound5_norming from '../../assets/sounds/nn/spoonerism/norming/grade6-7/test/Spoonerism-MT-5.mp3';
import nn_sound6_norming from '../../assets/sounds/nn/spoonerism/norming/grade6-7/test/Spoonerism-MT-6.mp3';
import nn_sound7_norming from '../../assets/sounds/nn/spoonerism/norming/grade6-7/test/Spoonerism-MT-7.mp3';
import nn_sound8_norming from '../../assets/sounds/nn/spoonerism/norming/grade6-7/test/Spoonerism-MT-8.mp3';
import nn_sound9_norming from '../../assets/sounds/nn/spoonerism/norming/grade6-7/test/Spoonerism-MT-9.mp3';
import nn_sound10_norming from '../../assets/sounds/nn/spoonerism/norming/grade6-7/test/Spoonerism-MT-10.mp3';
import nn_sound11_norming from '../../assets/sounds/nn/spoonerism/norming/grade6-7/test/Spoonerism-MT-11.mp3';
import nn_sound12_norming from '../../assets/sounds/nn/spoonerism/norming/grade6-7/test/Spoonerism-MT-12.mp3';
import nn_sound13_norming from '../../assets/sounds/nn/spoonerism/norming/grade6-7/test/Spoonerism-MT-13.mp3';
import nn_sound14_norming from '../../assets/sounds/nn/spoonerism/norming/grade6-7/test/Spoonerism-MT-14.mp3';
import nn_sound15_norming from '../../assets/sounds/nn/spoonerism/norming/grade6-7/test/Spoonerism-MT-15.mp3';
import nn_sound16_norming from '../../assets/sounds/nn/spoonerism/norming/grade6-7/test/Spoonerism-MT-16.mp3';
import nn_sound17_norming from '../../assets/sounds/nn/spoonerism/norming/grade6-7/test/Spoonerism-MT-17.mp3';
import nn_sound18_norming from '../../assets/sounds/nn/spoonerism/norming/grade6-7/test/Spoonerism-MT-18.mp3';

export const no = {
	spoonerismIntro: no_spoonerismIntro,
	spoonerismIntroEnd: no_spoonerismIntroEnd,
	proveoppgave1: no_proveoppgave1,
	correct1: no_correct1,
	incorrect1: no_incorrect1,
};

export const nn = {
	spoonerismIntro: nn_spoonerismIntro,
	spoonerismIntroEnd: nn_spoonerismIntroEnd,
	proveoppgave1: nn_proveoppgave1,
	correct1: nn_correct1,
	incorrect1: nn_incorrect1,
};

export const no_test = {
	sound1: no_sound1,
	sound2: no_sound2,
	sound3: no_sound6,
	sound4: no_sound15_norming,
	sound5: no_sound9,
	sound6: no_sound16_norming,
	sound7: no_sound11,
	sound8: no_sound12,
	sound9: no_sound13,
	sound10: no_sound14,
	sound11: no_sound15,
	sound12: no_sound16,
	sound13: no_sound17,
	sound14: no_sound18_norming,
	sound15: no_sound19,
	sound16: no_sound20,
};

export const nn_test = {
	sound1: nn_sound1,
	sound2: nn_sound2,
	sound3: nn_sound6,
	sound4: nn_sound15_norming,
	sound5: nn_sound9,
	sound6: nn_sound16_norming,
	sound7: nn_sound11,
	sound8: no_sound12,
	sound9: no_sound13,
	sound10: no_sound14,
	sound11: no_sound15,
	sound12: no_sound16,
	sound13: no_sound17,
	sound14: nn_sound18_norming,
	sound15: no_sound19,
	sound16: no_sound20,
};

export const no_norming = {
	spoonerismIntro: no_spoonerismIntro_norming,
	spoonerismIntroEnd: no_spoonerismIntroEnd_norming,
	proveoppgave1: no_proveoppgave1_norming,
	correct1: no_correct1_norming,
	incorrect1: no_incorrect1_norming,
	ifonecorrect1: no_if_one_correct1_norming,
};

export const nn_norming = {
	spoonerismIntro: nn_spoonerismIntro_norming,
	spoonerismIntroEnd: nn_spoonerismIntroEnd_norming,
	proveoppgave1: nn_proveoppgave1_norming,
	correct1: nn_correct1_norming,
	incorrect1: nn_incorrect1_norming,
	ifonecorrect1: nn_if_one_correct1_norming,
};

export const no_test_norming = {
	sound1: no_sound1_norming,
	sound2: no_sound2_norming,
	sound3: no_sound4_norming,
	sound4: no_sound5_norming,
	sound5: no_sound7_norming,
	sound6: no_sound10_norming,
	sound7: no_sound11_norming,
	sound8: no_sound12_norming,
	sound9: no_sound13_norming,
	sound10: no_sound14_norming,
	sound11: no_sound15_norming,
	sound12: no_sound17_norming,
};

export const nn_test_norming = {
	sound1: nn_sound1_norming,
	sound2: nn_sound2_norming,
	sound3: nn_sound4_norming,
	sound4: nn_sound5_norming,
	sound5: nn_sound7_norming,
	sound6: nn_sound10_norming,
	sound7: nn_sound11_norming,
	sound8: nn_sound12_norming,
	sound9: nn_sound13_norming,
	sound10: nn_sound14_norming,
	sound11: nn_sound15_norming,
	sound12: nn_sound17_norming,
};
